// src/components/Modal/Modal.jsx
import React, { useState, useEffect } from 'react';
import styles from './Modal.module.scss';

const Modal = ({ isOpen, onClose, children }) => {
  const [showClose, setShowClose] = useState(false);

  useEffect(() => {
    let rafId;
    if (isOpen) {
      // ocultamos la X inmediatamente
      setShowClose(false);
      // en el siguiente repaint, la mostramos
      rafId = requestAnimationFrame(() => {
        setShowClose(true);
      });
    } else {
      setShowClose(false);
    }
    return () => cancelAnimationFrame(rafId);
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div
        className={`${styles.content} ${showClose ? styles.visible : ''}`}
        onClick={e => e.stopPropagation()}
      >
        <button className={styles.close} onClick={onClose}>
          ×
        </button>
        {children}
      </div>
    </div>
  );
};

export default Modal;
